/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';
import BaseSelect from 'shared/ui/components/form-components/BaseSelect.vue';
import WizardStep from 'shared/ui/components/WizardStep.vue';

// Mixins
import baseWorkspaceSettings from 'ui/mixins/workspaces/base-settings';

// Utils

const __vue_script__ = {
    name: 'LocationTimezone',

    components: { BaseInput, BaseSelect },

    extends: WizardStep,

    mixins: [baseWorkspaceSettings],

    data() {
        return {
            countries: this.$utils.collections.getCountryListWithCodeForSelect(),
        };
    },

    computed: {
        country: {
            get() {
                if (!this.form.country) {
                    return [];
                }
                return this.countries.filter(c => this.form.country.includes(c.label));
            },

            set(country) {
                this.form.country = country.map(c => c.label);
                this.form.country_code = country.map(c => c.value);
            }
        }
    },

    methods: {
        /**
         * This handler is called upon form submission.
         *
         * @override
         */
        async submit() {
            return await this.$refs.form.validate();
        },

        /**
         * Utility method to make the template more readable
         *
         * @param {String} key the key to translate
         *
         * @return {String} the translated message
         */
        t(key) {
            return this.$i18n.t(`wizards.create_workspace.form.${key}`).toString();
        },

        /**
         * This handler is called when `org` changes and it initializes branded apps
         * We don't need apps in this section of the form hence the override
         *
         * @override
         */
        initializeApps() {}
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-observer',{ref:"form",staticClass:"location-timezone",attrs:{"tag":"form"},on:{"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}}},[_c('fieldset',[_c('legend',[_vm._v(_vm._s(_vm.t('fieldsets.venue')))]),_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"country"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-select',{attrs:{"errors":errors,"focused":_vm.focus == 'country',"label":_vm.t('country'),"options":_vm.countries,"placeholder":_vm.t('country_placeholder'),"multiple":true,"tip":_vm.t('country_tip'),"name":"country","track-by":"value"},model:{value:(_vm.country),callback:function ($$v) {_vm.country=$$v},expression:"country"}})]}}])}),_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"location"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-input',{attrs:{"label":_vm.t('city'),"type":"text","name":"location","focused":_vm.focus == 'city',"errors":errors,"tip":_vm.t('city_tip')},model:{value:(_vm.form.city),callback:function ($$v) {_vm.$set(_vm.form, "city", $$v)},expression:"form.city"}})]}}])}),_c('div',{staticClass:"grouped-controls"},[_c('div',{staticClass:"form-groups"},[_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"timezone"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-select',{ref:"timezone",attrs:{"errors":errors,"focused":_vm.focus == 'timezone',"label":_vm.t('timezone'),"options-label":null,"options":_vm.timezones,"placeholder":_vm.t('timezone_placeholder'),"name":"timezone"},model:{value:(_vm.form.timezone),callback:function ($$v) {_vm.$set(_vm.form, "timezone", $$v)},expression:"form.timezone"}})]}}])}),_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"servers_location"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-select',{ref:"servers_location",attrs:{"errors":errors,"focused":_vm.focus == 'servers_location',"label":_vm.t('servers_location'),"options":_vm.servers_locations,"placeholder":_vm.t('servers_location_placeholder'),"name":"servers_location","track-by":"value"},model:{value:(_vm.form.servers_location),callback:function ($$v) {_vm.$set(_vm.form, "servers_location", $$v)},expression:"form.servers_location"}})]}}])})],1)])],1)])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "LocationTimezone.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__